import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip-for-footer-card',
  template: `<div>{{ label }}</div>`,
  styleUrls: ['./tooltip-for-footer-card.component.scss'],
})
export class TooltipForFooterCardComponent {
  @Input() label: string = '';
}
